/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveconscientiousnessleft4Inputs */



/**
* | output |
* | --- |
* | "Improviser" |
*
* @param {Personalitybigfiveconscientiousnessleft4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveconscientiousnessleft4 = /** @type {((inputs?: Personalitybigfiveconscientiousnessleft4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveconscientiousnessleft4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Improviser")
	if (locale === "es") return /** @type {LocalizedString} */ ("Improvisador")
	return /** @type {LocalizedString} */ ("Импровизатор")
});
export { personalitybigfiveconscientiousnessleft4 as "personalityBigFiveConscientiousnessLeft" }